import React, { useState, useEffect } from 'react';
import Nav from "../components/Nav";
import "./Homepage.css";
import Scrolltop from '../components/Scrolltop';
import { Footer } from '../components/footer';

import { Upperbox } from '../components/Upperbox';

import Section1 from './Section1';
import Section2 from './Section2';
import Section3 from './Section3';
import Section4 from './Section4';
import Section5 from './Section5';
import Testimonials from './Testimonials';

import BannerGif from "../images/OpeningBanner.png"; 
import Countingsection from './Countingsection';

const Homepage = () => {
    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        // Check if popup has already been shown in this session
        const hasShownPopup = sessionStorage.getItem('hasShownPopup');
        if (!hasShownPopup) {
            
            const timer = setTimeout(() => {
                setShowPopup(true);
                sessionStorage.setItem('hasShownPopup', 'true');
            }, 5000); // 5 seconds delay

            return () => clearTimeout(timer); // Cleanup on component unmount
        }
    }, []);

    const handleClosePopup = () => {
        setShowPopup(false);
    };

    return (
        <div>
            <Upperbox />
            <Nav />
            {showPopup && (
                <div className="video-popup-overlay" onClick={handleClosePopup}>
                <div className="video-popup" onClick={(e) => e.stopPropagation()}>
    <img src={BannerGif} alt="Banner" className="popup-video" />
    <button className="close-button" onClick={handleClosePopup}>X</button>
    <button className="order-button" onClick={() => window.location.href = "/grababitenow"}>Order Now</button>
</div>


                </div>
            )}
            <Section1 />
            <Section2 />
            <Countingsection />
            <Section4 />
            <Section3 />
           
       
            <Section5 />
            <Testimonials />
         
         
            <Scrolltop />
           
         
            <Footer />
        </div>
    );
};

export default Homepage;
